import React from "react";
import {
  SimpleShowLayout,
  Show,
  TextField,
  SelectField,
  ArrayField,
  Datagrid,
  BooleanField,
  DateField,
  WithRecord,
  FunctionField,
} from "react-admin";
import { Grid } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { agreeStatus, dateOptions, paymentStatus, paymentType } from "../../../../utils/options";
import {
  raLabeledStyle,
  raSimpleShowLayoutFlexRow,
  raSimpleShowLayoutCellFlex,
  accordionTitle,
  sectionTitle,
  raLabeledStyleModify,
} from "../../../../customStyles/ra-custom-styles";
import { changedPropsLabel } from "../../../../utils/options";
const cellWidth = { width: "180px" };
const ShowEditions = () => {
  return (
    <Show
      title="Детайли за абонамент"
      sx={{ paddingBottom: "3rem" }}
    >
      <SimpleShowLayout>
        <TextField
          sx={{ fontSize: "18px", fontWeight: "bold" }}
          disabled
          label="Номер на поръчката"
          source="subscription_id"
          fullWidth
        />
        <TextField
          label="Име на заявител"
          source="giver_first_name"
          sortable={true}
        />
        <TextField
          label="Фамилия на заявител"
          source="giver_last_name"
          sortable={true}
        />
        <TextField
          label="Е-мейл на заявителя"
          source="giver_email"
        />
        <TextField
          label="Телефон на заявителя"
          source="giver_phone_number"
        />
        <TextField
          label="Име на получател"
          source="receiver_first_name"
        />
        <TextField
          label="Фамилия на получател"
          source="receiver_last_name"
          sortable={true}
        />
        <TextField
          label="Телефон на получател"
          source="receiver_phone_number"
          sortable={true}
        />
        <TextField
          label="Нас. място на получател"
          source="receiver_city"
        />
        <DateField
          label="Дата на заявка на абонамента"
          sortable={false}
          source="order_date"
          locales={"bg"}
          options={dateOptions}
        />
      </SimpleShowLayout>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography sx={accordionTitle}>Данни за абонамента</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ArrayField
            label="Поръчани издания"
            source="editions"
          >
            <Datagrid
              bulkActionButtons={false}
              sx={{
                "& .RaDatagrid-headerCell:last-child": {
                  width: "200px",
                },

                "& .RaDatagrid-headerCell:nth-child(5)": {
                  width: "155px",
                },
              }}
              fullWidth
            >
              <TextField
                label="Наименование"
                source="edition_name"
              />
              <TextField
                label="Кат. №"
                source="catalog_number"
              />
              <TextField
                label="Период на абонамент"
                source="months_count"
              />
              <TextField
                label="Ед. цена"
                source="single_edition_price"
              />
              <TextField
                label="Кол."
                source="editions_quantity"
              />
              <TextField
                label="Обща цена"
                source="total_edition_cost"
              />
            </Datagrid>
          </ArrayField>
          <div style={{ display: "flex", justifyContent: "spa360e-between" }}>
            <SimpleShowLayout
              sx={{
                "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
                "& .RaLabeled-label": raLabeledStyle,
              }}
            >
              <TextField
                label="Начало на абонамента : месец / година"
                source="subscription_start_date_month_and_year"
              />
            </SimpleShowLayout>
            <WithRecord
              render={record =>
                record.is_discount === true ? (
                  <SimpleShowLayout
                    sx={{
                      "& .RaSimpleShowLayout-row": raSimpleShowLayoutCellFlex,
                      "& .RaLabeled-label": raLabeledStyleModify,
                      flex: "0",
                      width: "360px",
                    }}
                  >
                    <TextField
                      label="Обща цена без отстъпката в лв"
                      source="total_sum_before_discount"
                      sx={cellWidth}
                    />
                    <BooleanField
                      label="Отстъпка"
                      source="is_discount"
                      sx={cellWidth}
                    />

                    <TextField
                      label="Процент отстъпка"
                      source="discount_percent"
                      sx={cellWidth}
                    />

                    <TextField
                      label="Размер на отстъпката в лв"
                      source="total_discount_sum"
                      sx={cellWidth}
                    />

                    <TextField
                      label="Крайна дължима сума след отстъпката в лв"
                      source="total_sum"
                      sx={cellWidth}
                    />
                  </SimpleShowLayout>
                ) : (
                  <SimpleShowLayout
                    sx={{
                      "& .RaSimpleShowLayout-row": raSimpleShowLayoutCellFlex,
                      "& .RaLabeled-label": raLabeledStyleModify,
                      flex: "0",
                      width: "360px",
                    }}
                  >
                    <TextField
                      label="Обща цена без отстъпката в лв"
                      source="total_sum_before_discount"
                      sx={cellWidth}
                    />
                    <TextField
                      label="Крайна дължима сума след отстъпката в лв"
                      source="total_sum"
                      sx={cellWidth}
                    />
                  </SimpleShowLayout>
                )
              }
            />
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography sx={accordionTitle}>Данни за получател и адрес на доставка</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={12}
              md={4}
              lg={4}
            >
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
                  "& .RaLabeled-label": raLabeledStyle,
                }}
              >
                <TextField
                  label="Аб.камп."
                  source="campaign_name"
                />

                <TextField
                  label="Име на заявител"
                  source="giver_first_name"
                  sortable={true}
                />
                <TextField
                  label="Фамилия на заявител"
                  source="giver_last_name"
                  sortable={true}
                />

                <TextField
                  label="Телефон на заявител"
                  source="giver_phone_number"
                />
              </SimpleShowLayout>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              lg={4}
            >
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
                  "& .RaLabeled-label": raLabeledStyle,
                }}
              >
                <TextField
                  label="Име на получател"
                  source="receiver_first_name"
                />
                <TextField
                  label="Фамилия на получател"
                  source="receiver_last_name"
                  sortable={true}
                />
                <TextField
                  label="E-мейл за доставка на ел изд."
                  source="receiver_email"
                />
                <TextField
                  label="Нас. място на получател"
                  source="receiver_city"
                />
                <TextField
                  label="ПК на получател"
                  source="receiver_postcode"
                />
                <TextField
                  label="Телефон на получател"
                  source="receiver_phone_number"
                />
              </SimpleShowLayout>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              lg={4}
            >
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
                  "& .RaLabeled-label": raLabeledStyle,
                }}
              >
                <TextField
                  label="Област"
                  source="receiver_district"
                />
                <TextField
                  label="Община"
                  source="receiver_municipality"
                />
                <TextField
                  label="Квартал"
                  source="receiver_neighborhood"
                />
                <TextField
                  label="Улица"
                  source="receiver_street"
                />
                <TextField
                  label="Улица номер"
                  source="receiver_street_number"
                />
              </SimpleShowLayout>
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutCellFlex,
                  "& .RaLabeled-label": raLabeledStyle,
                  "& .RaSimpleShowLayout-stack": raSimpleShowLayoutFlexRow,
                }}
              >
                <TextField
                  label="Блок"
                  source="receiver_building"
                />
                <TextField
                  label="Вход"
                  source="receiver_entrance"
                />
                <TextField
                  label="Етаж"
                  source="receiver_floor"
                />
                <TextField
                  label="Ап."
                  source="receiver_apartment"
                />
              </SimpleShowLayout>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <SimpleShowLayout>
        <Typography sx={sectionTitle}>Данни за плащане</Typography>
        <SelectField
          label="Начин на плащане"
          source="payment_type"
          choices={paymentType}
        />

        <SelectField
          label="Статус на плащане"
          source="payment_status"
          choices={paymentStatus}
        />
        <DateField
          label="Дата на плащане"
          source="purchase_date"
          locales={"bg"}
          options={dateOptions}
        />
      </SimpleShowLayout>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography sx={accordionTitle}>Данни за фактура</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
            >
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutCellFlex,
                  "& .RaLabeled-label": raLabeledStyle,
                  "& .RaSimpleShowLayout-stack": raSimpleShowLayoutFlexRow,
                }}
              >
                {/* <TextField
                  label="Начин на плащане"
                  source="payment_type"
                />
                <TextField
                  label="Статус на плащане"
                  source="payment_status"
                />
                <TextField
                  label="Дата на плащане"
                  source="purchase_date"
                  sortable={true}
                /> */}

                <SelectField
                  label="Желае фактура"
                  source="is_invoice_ordered"
                  choices={agreeStatus}
                  fullWidth
                  sx={{ marginTop: "0px", marginBottom: " 0px" }}
                />
                <SelectField
                  label="Издадена фактура"
                  source="is_invoice_given"
                  choices={agreeStatus}
                  emptyText="Не"
                  fullWidth
                />
                <TextField
                  label="Фактура номер"
                  source="invoice_number"
                  emptyText="Няма"
                  fullWidth
                />
              </SimpleShowLayout>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
            >
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
                  "& .RaLabeled-label": raLabeledStyle,
                }}
              >
                <TextField
                  label="Фирма"
                  source="invoice_company_name"
                />
                <TextField
                  label="Булстат / ЕГН"
                  source="invoice_identification_number"
                  fullWidth
                />
                <TextField
                  label="ИНЗДДС"
                  source="invoice_tax_id"
                  fullWidth
                />

                <TextField
                  label="Адрес на фирма"
                  source="invoice_company_address"
                />
                <TextField
                  label="ПК нa фирма"
                  source="invoice_company_postal_code"
                />
                <TextField
                  label="МОЛ"
                  source="invoice_accountable_person"
                />
                <TextField
                  label="E-мейл"
                  source="invoice_company_email"
                />
              </SimpleShowLayout>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
            >
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
                  "& .RaLabeled-label": raLabeledStyle,
                }}
              >
                <TextField
                  label="Име на получател"
                  source="invoice_billing_company_name"
                />
                <TextField
                  label="Допълнителен адрес за доставка"
                  source="invoice_billing_address"
                />
                <TextField
                  label="ПК на получател"
                  source="invoice_billing_postal_code"
                />
                <TextField
                  label="Лице за контакт на получател"
                  source="invoice_billing_accountable_person"
                />

                <TextField
                  label="Допълнителен E-мейл"
                  source="invoice_billing_email"
                />
              </SimpleShowLayout>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography sx={accordionTitle}>История на промените</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ArrayField
            label="История"
            source="editions_information_logs"
          >
            <Datagrid
              bulkActionButtons={false}
              fullWidth
            >
              <TextField
                label="Променено от"
                source="name"
              />
              <TextField
                label="Е-мейл"
                source="email"
              />
              <DateField
                label="Дата"
                source="log_date"
                locales={"bg"}
                options={dateOptions}
              />

              <FunctionField
                label="Променени данни за:"
                render={record =>
                  Object.keys(record.logs).map(prop => (
                    <Typography
                      component={"p"}
                      key={prop}
                    >
                      {changedPropsLabel[prop] && changedPropsLabel[prop] !== "Реклмация"
                        ? `${changedPropsLabel[prop]}  : ${record.logs[prop]?.split("T")[0]}`
                        : changedPropsLabel[prop] === "Реклмация"
                        ? `${changedPropsLabel[prop]} `
                        : null}
                    </Typography>
                  ))
                }
              />
            </Datagrid>
          </ArrayField>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography sx={accordionTitle}>Рекламации</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ArrayField
            label=""
            source="subscription_complaints"
          >
            <Datagrid
              bulkActionButtons={false}
              fullWidth
            >
              <TextField
                label="Текст"
                source="complaint"
              />
              <TextField
                source="answer"
                label="Отговор"
              />
            </Datagrid>
          </ArrayField>
        </AccordionDetails>
      </Accordion>
    </Show>
  );
};

export default ShowEditions;
